import React from 'react';
import { ReduxParallax } from './ReduxParallax';
import { Breakpoint } from '../Breakpoint/Breakpoint';
import { inverseResponsiveness } from './../../tools/Utils';
import './Parallax.scss';

export class ItemParallax extends React.PureComponent
{
	state = {}

	render()	
	{
		const {
					/* Parallax Props */
					area, parallax, isLoaded, windowY, scrollY, style, transform, speed,
					/* Breakpoint Props */
					small, medium, large, up, down, only,
					/* Pass Down Props */
					children,  ...props} = this.props;

		const breakpointProps = {small, medium, large, up, down, only};

		const parallaxProps = {area, parallax, isLoaded, windowY, scrollY, style, transform, speed, };
		
		const invertedBreakpoint = inverseResponsiveness(breakpointProps);

		return (
			<React.Fragment>
				<Breakpoint {...breakpointProps} >
					<ReduxParallax {...parallaxProps} >
						{(ref,style) => (
							<div className="holder-parallax" style={style} ref={ref} {...props}>
								{children}
							</div>
						)}
					</ReduxParallax>
				</Breakpoint>
				{invertedBreakpoint.map( (iBreakpoint,i)=>(
					<Breakpoint key={i} {...iBreakpoint} >
						<div className="holder-parallax" style={typeof style === 'function'?style(0):{}} {...props}>
							{children}
						</div>
					</Breakpoint>
				))}
			</React.Fragment>
		)
	}

}
